import api from '@/api'
export default {
  getCenterListBySystem (params) {
    return api({
      url: '/trainCamp/trainCampEnrollListSystem',
      method: 'GET',
      params
    })
  },
  getCenterListByOrg (params) {
    return api({
      url: '/trainCamp/trainCampEnrollListYouth',
      method: 'GET',
      params
    })
  },
  // 添加训练营报名
  addTrainCampEnroll (data) {
    return api({
      url: '/trainCamp/trainCampEnrollAdd',
      method: 'POST',
      data
    })
  },
  // 编辑训练营报名
  editTrainCampEnroll (data) {
    return api({
      url: '/trainCamp/trainCampEnrollEdit',
      method: 'POST',
      data
    })
  },
  // 获取训练营报名信息
  getTrainCampEnrollInfo(uuid){
    return api({
      url: `/trainCamp/trainCampEnrollInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 创建/编辑精英集训营报名时候的期数返回
  trainCampEnrollPeriod(year,type){
    return api({
      url: `/trainCamp/trainCampEnrollPeriod/${year}/${type}`,
      method: 'GET'
    })
  },
  // 获取大区训练营提交的球员列表--系统管理员
  getTrainCampPlanPlayerListSystem(params){
    return api({
      url: `/trainCamp/trainCampEnrollPlayerListSystem`,
      method: 'GET',
      params
    })
  },
  // 获取大区训练营提交的球员列表--会员协会
  getTrainCampPlanPlayerListYouth(params) {
    return api({
      url: '/trainCamp/trainCampEnrollPlayerListYouth',
      method: 'GET',
      params
    })
  },
  getTrainCampEnrollPlayerAll(uuid){
    return api({
      url: `/trainCamp/trainCampEnrollPlayerListAll/${uuid}`,
      method: 'GET'
    })
  },
  // 提交球员名单
  submitPlayerSave (data) {
    return api({
      url: '/trainCamp/trainCampEnrollPlayerSave',
      method: 'POST',
      data
    })
  },
}
